import { MenuT } from 'types/frontend/Menu';

// 나중에 다국어 함수로 대체
const t = (str: string) => str;

const reportMenuRootPath = '/teacherSide';
const lessonReportMenuRootPath = `${reportMenuRootPath}/lessonReport`;
const examMenuRootPath = `${reportMenuRootPath}/exam`;
const analysisReportMenuRootPath = `${reportMenuRootPath}/analysisReport`;

const reportMenu: MenuT = [
  {
    title: t('수업 리포트'),
    items: [
      {
        title: t('리포트 템플릿 관리'),
        path: `${lessonReportMenuRootPath}/template/list`,
        accessablePositions: ['director', 'assistantDirector'],
      },
      {
        title: t('리포트 생성'),
        path: `${lessonReportMenuRootPath}/group/add`,
      },
      {
        title: t('리포트 리스트'),
        path: `${lessonReportMenuRootPath}/group/list`,
      },
    ],
  },
  {
    title: t('시험'),
    items: [
      // {
      //   title: t('시험 템플릿 관리'),
      //   path: `${examMenuRootPath}/template/list`,
      //   accessablePositions: ['director', 'assistantDirector'],
      // },
      // {
      //   title: t('시험 생성'),
      //   path: `${examMenuRootPath}/group/add`,
      // },
      // {
      //   title: t('시험 리스트'),
      //   path: `${examMenuRootPath}/group/list`,
      // },
      {
        title: t('간단 시험 점수'),
        path: `${examMenuRootPath}/simpleExam`,
      },
    ],
  },
  // {
  //   title: t('성적 분석 리포트'),
  //   items: [
  //     {
  //       title: t('리포트 생성'),
  //       path: `${analysisReportMenuRootPath}/generate`,
  //       accessablePositions: ['director', 'assistantDirector'],
  //     },
  //   ],
  // },
];

export { reportMenu };
